import React from 'react'

import COLORS from 'constants/colors'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const NotApplicableButton = ({
  selected = false,
  hover = false,
  onPress,
}: {
  selected?: boolean
  hover?: boolean
  onPress: { (): void }
}) => {
  const { t } = useTranslation()

  return (
    <StyledNotApplicableButton
      selected={selected}
      hover={hover}
      onClick={onPress}
    >
      <div className="button-content">{t('notApplicable')}</div>
    </StyledNotApplicableButton>
  )
}

const StyledNotApplicableButton = styled.button`
  width: 192px;
  height: 56px;
  background-color: ${({ selected }) =>
    selected ? COLORS.LIGHT_TAG_YELLOW : 'white'};

  color: ${({ selected }) =>
    selected ? COLORS.SIXES_GREY : COLORS.SIXES_GREY};
  font-weight: ${({ selected, hover }) => (selected || hover ? '600' : '400')};
  font-size: 16px;

  border: ${({ selected, hover }) => (selected || hover ? '2px' : '1px')} solid
    ${({ selected, hover }) =>
      selected || hover ? COLORS.TAG_YELLOW : COLORS.LIGHTER_GREY};
  box-sizing: border-box;
  border-radius: 8px;

  .button-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:hover {
    cursor: pointer;
    border-width: 2px;
    border-color: ${COLORS.TAG_YELLOW};
    font-weight: 600;
  }
`

export default NotApplicableButton
